import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    salesTrainingName: '',
};

const salesTrainingViewSlice = createSlice({
    name: 'salesTrainingView',
    initialState,
    reducers: {
        setSalesTrainingName(state, action) {
            state.salesTrainingName = action.payload;
        },
        resetSalesTrainingName(state) {
            state.salesTrainingName = '';
        },
    },
});

export const { setSalesTrainingName, resetSalesTrainingName } = salesTrainingViewSlice.actions;
export default salesTrainingViewSlice.reducer;
